export default "__VITE_ASSET__059daad2__"